export function handleSelectionChange(
  textLayersMap: Map<HTMLDivElement, HTMLDivElement>,
  prevRange: Range | null
): Range | null {
  const selection = document.getSelection();
  const selectedText = selection?.toString?.()?.trim() || '';

  if (!selection || selection.rangeCount === 0 || !selectedText) {
    return null;
  }

  const activeTextLayers = new Set<HTMLDivElement>();

  for (let i = 0; i < selection.rangeCount; i++) {
    const range = selection.getRangeAt(i);
    for (const textLayerDiv of textLayersMap.keys()) {
      if (
        !activeTextLayers.has(textLayerDiv) &&
        range.intersectsNode(textLayerDiv)
      ) {
        activeTextLayers.add(textLayerDiv);
      }
    }
  }

  const range = selection.getRangeAt(0);

  const modifyStart =
    prevRange &&
    (range.compareBoundaryPoints(Range.END_TO_END, prevRange) === 0 ||
      range.compareBoundaryPoints(Range.START_TO_END, prevRange) === 0);

  let anchor: any = modifyStart ? range.startContainer : range.endContainer;
  if (anchor.nodeType === Node.TEXT_NODE) {
    anchor = anchor.parentNode;
  }

  if (!modifyStart && range.endOffset === 0) {
    do {
      while (!anchor.previousSibling) {
        anchor = anchor.parentNode;
      }
      anchor = anchor.previousSibling;
    } while (!anchor.childNodes.length);
  }

  const parentTextLayer = anchor.parentElement?.closest('.textLayer');
  if (!parentTextLayer) return null;

  const endDiv = textLayersMap.get(parentTextLayer as HTMLDivElement);

  if (
    endDiv instanceof HTMLDivElement &&
    parentTextLayer instanceof HTMLDivElement
  ) {
    endDiv.style.width = parentTextLayer.style.width;
    endDiv.style.height = parentTextLayer.style.height;
    anchor.parentElement?.insertBefore(
      endDiv,
      modifyStart ? anchor : anchor.nextSibling
    );
  }
  return range.cloneRange();
}
